import { z, isAsync } from 'zod/v3'
import type { ParseInput, SyncParseReturnType } from 'zod/v3'

/*
We override the _parseSync method of ZodType to add custom error messages to the issues array.
This function is called by both the parse and safeParse methods of ZodType.

Let's hope we never have to use parseAsync or safeParseAsync, because we'll be doomed if we
have to override the internal function for those as well,
as it is much more complex than _parseSync.
*/

// TODO: NLP-4110 - This is outdated and needs updating
z.ZodType.prototype._parseSync = function (
  input: ParseInput
): SyncParseReturnType {
  const result = this._parse(input)
  if (isAsync(result)) {
    throw new Error('Synchronous parse encountered promise.')
  }
  if (input.parent.common.issues.length > 0) {
    /*
    We have to use splice since we can't assign to the issues array directly, since it's a readonly array.
    
    Splice for some reason is still allowed to modify the array in place,
    so we use it to insert the custom error message at the end of the array.
    */

    // Because passing `-1` as index does not work when adding with splice, only when removing...
    const arrayLength = input.parent.common.issues.length

    const customErrorDataMessage = `Data: ${JSON.stringify(input.data)}`
    input.parent.common.issues.splice(arrayLength, 0, {
      code: 'custom',
      message: customErrorDataMessage,
      path: [],
    })

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const description = this._def.description as string | undefined
    if (description) {
      const customErrorDescriptionMessage = `Schema Description: ${description}`
      input.parent.common.issues.splice(arrayLength + 1, 0, {
        code: 'custom',
        message: customErrorDescriptionMessage,
        path: [],
      })
    }
  }

  return result
}
